// ⚠️ AUTOMATICALLY GENERATED - DO NOT CHANGE
const CHANNEL = '677caa6a';
export const MAIN = '=' + CHANNEL;
export const WORKER = '-' + CHANNEL;
